module.exports = __webpack_public_path__ + "static/portfolio-8-48bdb37fe224a8c33cf1bcb1cb5fe806.jpg";